<template>
    <div>
        <div class="p-col-12 p-md-12" v-if="progresso > 0"> 
            Aguarde! Atualizando ponto...<i class="pi pi-spin pi-spinner" ></i>
            <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>
        </div>
        <IKFiltroFuncionarioContrato ref="ikFiltroFuncionarios"/>
		<div class="p-fluid p-formgrid p-grid p-mt-5">
            <div class="p-field p-col-12 p-md-12">
                <label>Justificativa</label>
                <Dropdown v-model.number="idJustificativaSelecionada" :options="justificativas" optionLabel="descricao" 
                    optionValue="id" dataKey="id" :filter="true" placeholder="Selecione"/>
            </div>  
            <div class="p-field p-col-12 p-md-12">
                <label>Observação</label>
                <Textarea v-model.trim="ocorrencia.observacao" rows="5" cols="30" @keyup="contarCaracteres"/>
            </div>                     
        </div>
        <h6 class="p-text-bold">Abrangência</h6>
        <div class="p-formgroup-inline">
            <div class="p-field-checkbox">
                <Checkbox v-model="ocorrencia.abrangeFaltas" :binary="true"/>
                <label>Falta</label>
            </div>
            <div class="p-field-checkbox">
                <Checkbox v-model="ocorrencia.abrangeFaltaMarcacao" :binary="true"/>
                <label>Falta de marcação</label>
            </div>
            <div class="p-field-checkbox">
                <Checkbox v-model="ocorrencia.abrangeAtrasos" :binary="true"/>
                <label>Atraso</label>
            </div>
            <div class="p-field-checkbox">
                <Checkbox v-model="ocorrencia.abrangeSaidaAntecipada" :binary="true"/>
                <label>Saída antecipada</label>
            </div>
            <div class="p-field-checkbox">
                <Checkbox v-model="ocorrencia.abrangeExcessoRefeicao" :binary="true"/>
                <label>Excesso no int. da refeição</label>
            </div>							
        </div>  
        <h6 class="p-text-bold">Período</h6>  
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Data início</label>
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Data final</label>
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
            </div>
        </div>
        <Button label="Salvar" icon="pi pi-check" class="p-mt-3" @click="salvar" v-if="permissaoNovo"/>
    </div>
</template>

<script>
import IKFiltroFuncionarioContrato from '@/components/template/IKFiltroFuncionarioContrato.vue';
import JustificativaService from '@/service/JustificativaService';
import OcorrenciaService from '@/service/OcorrenciaService';
import ControlePontoService from '@/service/ControlePontoService.js';
import Ocorrencia from '@/model/Ocorrencia';
import { exibirMensagem, exibirMensagemSis, clonar, localeCalendarBR} from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    ocorrenciaService: null,
    justificativaService: null,
	data() {
		return {
            permissaoNovo: false,
            ocorrencia: new Ocorrencia(),			
            dataInicio: new Date(),
			dataFinal: new Date(),
			idJustificativaSelecionada: null,
			justificativas: [],
            localeCalendarBR: localeCalendarBR,
            progresso: 0,
            pararTimeout: false,
		}
	},
	methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        /**
         * 
         */
        salvar() {          
            let filtro = this.$refs.ikFiltroFuncionarios.getFiltro();
            let funcionarios = filtro.funcionarios;          
            if(funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            if(this.idJustificativaSelecionada == null) {
                exibirMensagemSis(this, 'Selecione uma justificativa', true);
                return;
            }		
            if(!this.ocorrencia.abrangeFaltas && !this.ocorrencia.abrangeAtrasos && !this.ocorrencia.abrangeSaidaAntecipada
                && !this.ocorrencia.abrangeExcessoRefeicao && !this.ocorrencia.abrangeFaltaMarcacao) {
                exibirMensagemSis(this, 'Selecione uma abrangência', true);
                return;
            }	
            let justificativa = null;
            for(let i = 0; i < this.justificativas.length; i++) {
                if(this.idJustificativaSelecionada == this.justificativas[i].id) {
                    justificativa = {...this.justificativas[i]};
                }
            }		
            let ocorrencia = {...this.ocorrencia};
            let usuario = this.getDadosRequisicao().usuario;
            ocorrencia.usuarioJustificativa = usuario.nome + '-' + usuario.email.split('@')[0];
            ocorrencia.dia = this.formatarData(ocorrencia.dia);
            let requisicao = {
                cnpj: filtro.cnpj,
                funcionarios: clonar(funcionarios),
                justificativa: justificativa,
                ocorrencia: ocorrencia,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.ocorrenciaService.salvar(requisicao)
            .then(resp => {          
                this.ocorrencia = new Ocorrencia();
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                } 
                if(resp.data instanceof Array && resp.data.length > 0) {
                    this.atualizarPonto(resp.data);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)});   
		},
        /**
         * 
         */
         atualizarPonto(rangeDatas) {
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro(); 
            this.$refs.ikFiltroFuncionarios.limparSelecionados();           
            let requisicoes = [];                   
            const fabricaRequisicoes = {
                criar: (range, dados) => {
                    return {
                        mes: range.mes,
                        ano: range.ano,
                        dataInicio: range.dataInicio,
                        dataFinal: range.dataFinal,
                        cnpj: dados.cnpj,
                        funcionarios: [],      
                        usuarioRequisicao: this.getDadosRequisicao(),          
                    };
                }
            }
            rangeDatas.forEach(range => {
                let requisicao = fabricaRequisicoes.criar(range, dados);
                requisicoes.push(requisicao);
                let qtd = 0;
                dados.funcionarios.forEach(funcio => {                
                    if(qtd < 5) {                        
                        qtd++;
                    } else {
                        qtd = 1;
                        requisicao = fabricaRequisicoes.criar(range, dados);
                        requisicoes.push(requisicao);
                    }
                    requisicao.funcionarios.push(funcio);
                }); 
            });                 
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.progresso = 1;             
            this.calcularPeriodoEditadoRecursivo(1, requisicoes);
        },
        /**
         * 
         */
        calcularPeriodoEditadoRecursivo(pagina, requisicoes) {         
            if(this.pararTimeout) {
                return;
            }  
            let requisicao = requisicoes[(pagina-1)];          
            this.controlePontoService.calcularPeriodoEditado2(requisicao, 'fdb=f')
            .then(()=>{
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    setTimeout(() => { this.progresso = 0; }, 1000);
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.calcularPeriodoEditadoRecursivo(pagina, requisicoes);
                    }, 500);
                } 
            })
            .catch(erro => {                   
                exibirMensagem(this, erro);
                setTimeout(() => { this.progresso = 0; }, 3000);
            });
        },
        /**
         * 
         */
		listarJustificativas() {	
			this.justificativaService.listar({...this.getDadosRequisicao()})
				.then(resp => {
                    this.justificativas = resp.data;                    
                })
                .catch(erro => {exibirMensagem(this, erro)});   
		},
        /**
         * 
         */
        contarCaracteres() {
            if(this.observacao.length > 300) {
                this.observacao = this.observacao.substring(0, 300);
            }
        },
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(109);		
		}
	},
	created() {
        this.controlePontoService = new ControlePontoService();
        this.ocorrenciaService = new OcorrenciaService();
		this.justificativaService = new JustificativaService();
	},
	mounted() {
        this.listarJustificativas();
        this.validarPermissoes();
	},
    beforeDestroy() {
        this.pararTimeout = true;
    },
	components: {
        'IKFiltroFuncionarioContrato': IKFiltroFuncionarioContrato,
    }
}
</script>

<style>

</style>